// Petakan token antd -> CSS variable, supaya SCSS ikut theme light/dark otomatis
// dan tetap konsisten saat komponen dirender di portal (Drawer).
export const buildLowStockCssVars = (token) => ({
  '--ls-warn': token.colorWarning,
  '--ls-warn-bg': token.colorWarningBg,
  '--ls-warn-border': token.colorWarningBorder,
  '--ls-warn-text': token.colorWarningText,
  '--ls-crit': token.colorError,
  '--ls-crit-bg': token.colorErrorBg,
  '--ls-crit-border': token.colorErrorBorder,
  '--ls-crit-text': token.colorErrorText,
  '--ls-primary': token.colorPrimary,
  '--ls-surface': token.colorBgContainer,
  '--ls-surface-2': token.colorFillQuaternary,
  '--ls-border': token.colorBorderSecondary,
  '--ls-text': token.colorText,
  '--ls-muted': token.colorTextSecondary,
  '--ls-faint': token.colorTextTertiary,
  '--ls-radius': `${token.borderRadiusLG}px`,
  '--ls-shadow': token.boxShadowTertiary,
})
